export const baseUrl = "https://spotlight-api.skill-mine.com";
export const group_id = "spotlight-main";
export const BASE_URL = "https://smtc-api.auth-zero.com";
export const CLEAINT_ID = "bfdf954f-c39b-4e1c-9502-f0cf600cbf66";
export const webUrl = "https://spotlight.skill-mine.com";